import { STATUS_TYPE } from '../../../enum';

export interface AffiliateGroup {
  id: number;
  name: string;
  code: string;
  status: number;
  price: number;
  created_at: Date;
  updated_at: Date;
}

interface InitialState {
  data: AffiliateGroup[];
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
